module.exports = __webpack_public_path__ + "static/chazki-0a5e30d21d80d25a584eac3a56b5298c.png";